import jwt_decode from "jwt-decode";

function hasCompleteCredentials(creds = {}) {
	return Boolean(creds.cloud_name && creds.cloud_key && creds.cloud_secret);
}

function pickCredentials(source = {}) {
	return {
		cloud_name: source.cloud_name,
		cloud_key: source.cloud_key,
		cloud_secret: source.cloud_secret,
	};
}

export function getRadioCloudinaryCredentials(override) {
	if (override) {
		const creds = pickCredentials(override);
		return hasCompleteCredentials(creds) ? creds : {};
	}

	const token = localStorage.getItem("APP_01");
	if (!token) {
		return {};
	}

	const radio = jwt_decode(token).radio || {};
	const creds = pickCredentials(radio);
	return hasCompleteCredentials(creds) ? creds : {};
}

export function extractCloudinaryPublicId(url) {
	if (!url || typeof url !== "string") {
		return null;
	}
	const segment = url.split("/")[9];
	if (!segment) {
		return null;
	}
	return segment.split(".")[0];
}
